/**
 * @description 审批接口
 */
import request from '@/utils/request'

// 审批列表
export const getApproveList = data => (request({
    data,
    method: 'POST',
    url: 'approve/get_list'
}))

// 详情
export const getDetail = data => (request({
    data,
    method: 'POST',
    url: 'approve/get_detail'
}))

// 信息
export const getInfo = data => (request({
    data,
    method: 'POST',
    url: 'approve/get_info'
}))

// 审批
export const putAudit = data => (request({
    data,
    method: 'POST',
    url: 'approve/audit'
}))

// 修改
// Useless Api
export const editApprove = data => (request({
    data,
    method: 'POST',
    url: 'approve/edit'
}))

/**
 * @description 获取用户审批待处理统计
 */
export const getUserApproveCount = () => (request({
    method: 'POST',
    url: 'approve/get_count',
}))

export const postFeedbackResult = data => (request({
    data,
    method: "POST",
    url: "approve/feedback"
}))